import { useState } from "react";
import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { isDraftSpace } from "@/react/helpers/spaceHelpers";
import { Tab } from "@circle-react-shared/uikit/TabV2";
import { Typography } from "@circle-react-uikit/Typography";
import { Comments } from "./Comments";
import { QuizResults } from "./QuizResults";
import { StudentsTable } from "./StudentsTable";

export const Engagement = ({ space }) => {
  const TAB_OPTIONS = [
    {
      label: t("courses.admin_summary.students"),
      className: "!text-sm",
    },
    {
      label: t("courses.admin_summary.comments"),
      className: "!text-sm",
    },
    {
      label: t("courses.admin_summary.quiz_results"),
      className: "!text-sm",
    },
  ];

  const [activeTab, setActiveTab] = useState(TAB_OPTIONS[0].label);

  if (isDraftSpace(space)) {
    return (
      <div className="flex h-full flex-col items-center justify-center py-10">
        <div className="text-dark text-center">
          <Typography.TitleMd as="h3" weight="medium">
            {t("courses.admin_summary.engagement.draft.title")}
          </Typography.TitleMd>
          <div className="mt-5">
            <Typography.BodySm weight="medium">
              {t("courses.admin_summary.engagement.draft.description")}
            </Typography.BodySm>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="border-primary space-y-2 rounded-lg border py-4 md:border-none">
      <div className="px-6 md:px-0">
        <Typography.TitleSm as="h3">
          <span className="text-base font-medium md:text-xl md:font-semibold">
            {t("courses.admin_summary.engagement.title")}
          </span>
        </Typography.TitleSm>
      </div>
      <div className="border-primary border-b">
        <Tab.Group
          className="overflow-hidden"
          selectedIndex={TAB_OPTIONS.map(tab => tab.label).indexOf(activeTab)}
        >
          <div className="border-primary border-b px-6 md:px-0">
            <Tab.List>
              {Object.values(TAB_OPTIONS).map(tab => (
                <Tab
                  key={tab.label}
                  className="text-sm"
                  onClick={() => {
                    setActiveTab(tab.label);
                  }}
                >
                  <div className="flex items-center gap-1">{tab.label}</div>
                </Tab>
              ))}
            </Tab.List>
          </div>
        </Tab.Group>
      </div>
      <div className="px-6 md:px-0">
        {activeTab === t("courses.admin_summary.students") && (
          <StudentsTable space={space} />
        )}
        {activeTab === t("courses.admin_summary.comments") && (
          <Comments space={space} />
        )}
        {activeTab === t("courses.admin_summary.quiz_results") && (
          <QuizResults space={space} />
        )}
      </div>
    </div>
  );
};

Engagement.propTypes = {
  space: PropTypes.object.isRequired,
};
